import React from 'react';
import { Star } from 'lucide-react';

const testimonials = [
  {
    quote: "You guys are the next frontier with health in America",
    name: "Anthony Lolli",
    title: "Founder of BiohackYourself Media",
    description: "Producer of the Biohack Yourself series, where he's interviewed over 100 leading experts, and publisher of a national biohacking magazine. Anthony is also the executive producer of the upcoming Amazon Prime documentary sHEALed, featuring Dr. Steve Moore and Ryan Encinas, highlighting breakthrough science in wellness and longevity."
  },
  {
    quote: "The future of personalized medicine",
    name: "William Sears, MD",
    title: "World-renowned physician",
    description: "Best-selling author of more than 40 health and wellness books, and co-founder of the Dr. Sears Wellness Institute, which has trained thousands of health coaches worldwide. A leading voice in preventive medicine, Dr. Sears has been featured on major media outlets including The Today Show, Good Morning America, and CNN."
  },
  {
    quote: "A great tool to quantify wellness",
    name: "Del Bigtree",
    title: "CEO of MAHA Action",
    description: "Award-winning producer of the TV show The Doctors, and founder of the Informed Consent Action Network (ICAN). He is also the host of The HighWire, one of the fastest-growing health news and talk shows, where he brings cutting-edge science and thought leaders to a global audience."
  },
  {
    quote: "I am getting better outcomes with my patients",
    name: "Ben Gonzalez, MD",
    title: "Key Opinion Leader",
    description: "Expert in functional medicine and longevity. He is a keynote speaker at A4M and other leading integrative medical conferences, widely known for blending science with personalized wellness strategies to deliver consistent, measurable results."
  }
];

const mediaLogos = [
  { name: "Stanford University", url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/1wMf7T7aH8D1ie1bclKY/media/2a5c3d51-72ea-40d4-ac8e-440368a0404b.png" },
  { name: "Yale Cancer Center", url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/1wMf7T7aH8D1ie1bclKY/media/76fff2af-0f86-4293-a577-1bd0c93fdb44.png" },
  { name: "Dr. Oz Show", url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/kegvalbzpQofSzg76KLV/media/68a528cf034eda07feb4cbc8.png" },
  { name: "CBS", url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/kegvalbzpQofSzg76KLV/media/68a52952406eea028f3d3bb8.png" },
  { name: "Discovery Channel", url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/kegvalbzpQofSzg76KLV/media/68a528d2406eea40213d2dda.png" },
  { name: "NIH", url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/1wMf7T7aH8D1ie1bclKY/media/130570a1-11b2-4de0-bb4d-eaa5e076008a.png" }
];

const TestimonialsSection = () => {
  return (
    <section className="w-full">
      {/* Testimonials */}
      <div className="bg-gradient-to-b from-[#1a1f2e] to-[#0f1219] py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4">
          {/* Header */}
          <div className="text-center mb-12">
            <p className="text-teal-400 text-sm uppercase tracking-widest mb-3">TESTIMONIALS</p>
            <h2 className="text-white text-3xl md:text-4xl lg:text-5xl font-bold">
              What others are saying.
            </h2>
          </div>

          {/* Testimonial Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index} 
                className="bg-[#1e2536] rounded-xl p-6 md:p-8 border border-gray-700/50 hover:border-teal-500/30 transition-all"
              >
                <h3 className="text-white text-xl md:text-2xl font-semibold mb-4 italic">
                  "{testimonial.quote}"
                </h3>
                <p className="text-teal-400 font-semibold text-lg mb-1">
                  {testimonial.name}
                </p>
                <p className="text-gray-400 text-sm mb-4">
                  {testimonial.title}
                </p>
                <p className="text-gray-300 text-sm leading-relaxed mb-4">
                  {testimonial.description}
                </p>
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={18} className="text-yellow-400 fill-yellow-400" />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* In the Spotlight */}
      <div className="bg-gradient-to-b from-[#0f1219] to-[#1a1f2e] py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4">
          {/* Header */}
          <div className="text-center mb-12">
            <p className="text-teal-400 text-sm uppercase tracking-widest mb-3">IN THE SPOTLIGHT</p>
            <h2 className="text-white text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              University & Media Coverage
            </h2>
            <p className="text-gray-400 text-lg">
              25 Million Scans - 100+ Studies - Over $1 Billion Invested
            </p>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap justify-center gap-8 md:gap-16 mb-12">
            <div className="text-center">
              <p className="text-teal-400 text-2xl md:text-3xl font-bold">Over $1 Billion</p>
              <p className="text-gray-400 text-sm">Invested</p>
            </div>
            <div className="text-center">
              <p className="text-teal-400 text-2xl md:text-3xl font-bold">25 Million</p>
              <p className="text-gray-400 text-sm">Scans</p>
            </div>
            <div className="text-center">
              <p className="text-teal-400 text-2xl md:text-3xl font-bold">100+</p>
              <p className="text-gray-400 text-sm">Studies</p>
            </div>
          </div>

          {/* Media Logos */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
            {mediaLogos.map((logo, index) => (
              <div 
                key={index} 
                className="bg-[#1e2536] rounded-lg p-4 md:p-6 flex items-center justify-center h-24 md:h-28 border border-gray-700/30 hover:border-teal-500/30 transition-all"
              >
                <img 
                  src={logo.url} 
                  alt={logo.name} 
                  className="max-h-12 md:max-h-16 w-auto object-contain filter brightness-0 invert opacity-80 hover:opacity-100 transition-opacity"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
